module.exports = __webpack_public_path__ + "static/media/laboral.176437dd.png";